"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _TimezoneTypes = _interopRequireDefault(require("../constants/TimezoneTypes"));

var _RelativeDurationFormats = _interopRequireDefault(require("../constants/RelativeDurationFormats"));

var _formatRelativeDuration = _interopRequireDefault(require("../utils/formatRelativeDuration"));

var getRelativeDuration = function getRelativeDuration(from, to, options) {
  return (0, _formatRelativeDuration.default)(_I18n.default.moment.duration(Math.abs(to.diff(from))), options);
};

var _default = _react.default.createClass({
  displayName: "FormattedDuration",
  propTypes: {
    includeAffix: _react.PropTypes.bool,
    type: _react.PropTypes.oneOf([_TimezoneTypes.default.PORTAL, _TimezoneTypes.default.USER, _TimezoneTypes.default.UTC]),
    format: _react.PropTypes.oneOf(Object.keys(_RelativeDurationFormats.default).map(function (format) {
      return _RelativeDurationFormats.default[format];
    })),
    from: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.number, _react.PropTypes.array]),
    to: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.number, _react.PropTypes.array]),
    toFromValidator: function toFromValidator(props, propName, componentName) {
      if (!props.from && !props.to) {
        console.warn(componentName + " should have either a \"to\" or a \"from\" prop", componentName);
      }
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      type: _TimezoneTypes.default.PORTAL,
      includeAffix: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        includeAffix = _this$props.includeAffix,
        type = _this$props.type,
        from = _this$props.from,
        to = _this$props.to,
        format = _this$props.format;

    var nowMoment = _I18n.default.moment[type]();

    var duration;

    if (!to && !from) {
      duration = '';
    } else if (!to) {
      var fromValue = _I18n.default.moment[type](from);

      duration = format ? getRelativeDuration(fromValue, nowMoment, {
        format: format
      }) : fromValue.toNow(!includeAffix);
    } else if (!from) {
      var toValue = _I18n.default.moment[type](to);

      duration = format ? getRelativeDuration(nowMoment, toValue, {
        format: format
      }) : toValue.fromNow(!includeAffix);
    } else {
      var _fromValue = _I18n.default.moment[type](from);

      var _toValue = _I18n.default.moment[type](to);

      duration = format ? getRelativeDuration(_fromValue, _toValue, {
        format: format
      }) : _toValue.from(_fromValue, !includeAffix);
    }

    return _react.default.createElement("span", null, duration);
  }
});

exports.default = _default;
module.exports = exports.default;